/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_AddedInputs */



/**
* | output |
* | --- |
* | "Added to Wundo" |
*
* @param {Agenda_AddedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_added = /** @type {((inputs?: Agenda_AddedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_AddedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toegevoegd aan Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouté à Wundo")
	return /** @type {LocalizedString} */ ("Added to Wundo")
});